/* 🤖 this file was generated by svg-to-ts */
export const matIconFolderCopy: {
  name: 'folder-copy';
  data: string;
} = {
  name: 'folder-copy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 19h17v2H3c-1.1 0-2-.9-2-2V6h2v13zM23 6v9c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2l.01-11c0-1.1.89-2 1.99-2h5l2 2h7c1.1 0 2 .9 2 2zM7 15h14V6h-7.83l-2-2H7v11z"/></svg>`
};
